import type { InfiniteData, QueryClient } from "@tanstack/react-query";
import { ChatKeys } from "web_myplann/Api/Chat/ChatKeys";
import type {
	ConversationListItemResponseDTO,
	ConversationListResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";

type ChatListCache = InfiniteData<ConversationListResponseDTO, number>;

export const markChatConversationRead = (
	queryClient: QueryClient,
	conversationId: number,
	unreadCount: number,
) => {
	const updateConversation = (conversation: ConversationListItemResponseDTO) =>
		conversation.id === conversationId
			? { ...conversation, unreadCount }
			: conversation;

	queryClient.setQueriesData<ChatListCache>(
		{ queryKey: ChatKeys.list() },
		(cache) =>
			cache && {
				...cache,
				pages: cache.pages.map((page) => ({
					...page,
					data: page.data.map(updateConversation),
				})),
			},
	);
};
